module.exports = __webpack_public_path__ + "img/It-T200.33d138e9.gif";